<template>
  <ProductPageLayout
    name="芊荨记事本笔记"
    :logo="logo"
    :hero-image="heroImage"
    lead="专注本地写作与整理的 Windows 笔记软件：笔记本分类、日记待办、标签与全文搜索，数据存本机不上传。"
    :feature-lines="featureLines"
    download-link="/ftp/packages/luckynote/LuckyNoteSetup.exe"
    download-file-name="LuckyNoteSetup.exe"
    :meta-items="metaItems"
    :detailed-features="detailedFeatures"
    :other-features="otherFeatures"
    :reviews="reviews"
    features-desc="三栏布局覆盖笔记本、列表与编辑，日记待办与标签整理一站完成。"
    other-desc="面向工作记录、学习笔记与私人日记场景，干净无捆绑。"
    reviews-desc="真实反馈持续驱动笔记体验与本地效率优化。"
  />
</template>

<script>
import ProductPageLayout from '@/components/ProductPageLayout.vue'

export default {
  name: 'LuckyNote',
  components: { ProductPageLayout },
  data() {
    return {
      logo: require('@/assets/luckynote/luckynote_48x48.png'),
      heroImage: require('@/assets/luckynote/全部笔记.png'),
      featureLines: [
        '笔记本分类 / 富文本编辑 / 标签整理 / 全文搜索',
        '日记 / 待办清单 / 回收站 / 本地加密'
      ],
      metaItems: [
        { icon: 'history', label: '本地笔记' },
        { icon: 'calendar', label: '日记待办' },
        { icon: 'lock', label: '数据不上传' }
      ],
      detailedFeatures: [
        {
          title: '全部笔记一览',
          brief: '三栏布局，笔记本 · 列表 · 编辑一目了然。',
          detail: '左侧笔记本树、中间笔记列表、右侧编辑区协同工作，写稿、翻阅与整理不必在多个窗口间切换。',
          image: require('@/assets/luckynote/全部笔记.png')
        },
        {
          title: '笔记本分类',
          brief: '按主题归档，长期知识库更清晰。',
          detail: '支持多笔记本管理与切换，工作、学习与私人内容分区存放，换机时拷贝数据库文件即可继续使用。',
          image: require('@/assets/luckynote/笔记本.png')
        },
        {
          title: '日记与待办',
          brief: '按日记录灵感，清单勾选同步推进。',
          detail: '日记页方便按日期回顾，待办页聚焦任务完成状态，笔记内清单也可与待办联动，兼顾写作与执行。',
          image: require('@/assets/luckynote/日记.png')
        },
        {
          title: '标签与回收站',
          brief: '多维归类好找，误删也能恢复。',
          detail: '用标签给笔记打上主题标记，配合全文搜索快速定位；删除内容进入回收站，需要时可恢复，降低误操作风险。',
          image: require('@/assets/luckynote/标签.png')
        }
      ],
      otherFeatures: [
        { title: '待办清单', description: '独立待办页管理任务，勾选进度一目了然。', icon: 'puzzle' },
        { title: '全文搜索', description: '标题、正文与标签均可检索，笔记再多也好找。', icon: 'search' },
        { title: '本地加密', description: '单篇加密与笔记库密码，数据只存本机。', icon: 'lock' },
        { title: '回收站', description: '误删笔记可恢复，整理时更安心。', icon: 'history' }
      ],
      reviews: [
        { name: '林编辑', comment: '本地三栏笔记很顺手，写稿和归类不用开云端账号，隐私感更好。', avatar: require('@/assets/luckynote/avatar1.jpg') },
        { name: '周运营', comment: '待办和笔记放一起，活动清单勾完还能回溯相关记录。', avatar: require('@/assets/luckynote/avatar2.jpg') },
        { name: '吴开发', comment: '全文搜索找会议纪要很快，标签分类后项目资料不再乱。', avatar: require('@/assets/luckynote/avatar3.jpg') },
        { name: '陈设计', comment: '日记功能适合记录灵感，界面干净，不影响创作状态。', avatar: require('@/assets/luckynote/avatar4.jpg') },
        { name: '黄产品', comment: '多笔记本切换清楚，换电脑拷贝数据库就能继续用。', avatar: require('@/assets/luckynote/avatar5.jpg') },
        { name: '赵学生', comment: '学习笔记和待办一起管，复习前搜索关键词特别方便。', avatar: require('@/assets/luckynote/avatar6.jpg') }
      ]
    }
  }
}
</script>
